import { Toaster } from 'react-hot-toast';

// Wraps react-hot-toast's <Toaster /> with our wedding palette and copy
// conventions. Mount it once near the root of the tree.
export default function Toast() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          borderRadius: '0.5rem',
          background: '#2c2c2c',
          color: '#ffffff',
          fontFamily: 'var(--font-body)',
          fontSize: '0.9rem',
        },
        success: { iconTheme: { primary: '#708238', secondary: '#ffffff' } },
        error: { iconTheme: { primary: '#b33a3a', secondary: '#ffffff' } },
      }}
    />
  );
}
